import { connect } from 'react-redux';
import { episodePlayerStart } from 'store/playerPodCast/playerPodCast.actions';
import {
  requestNextPodcastEpisode,
  // fetchPodCastListStart
  setPlayerPlaylist
} from 'store/podcast/podcast.actions';
import { fetchPodCastEpisodeStart } from 'store/podcastPlaylist/podcastPlaylist.actions';

const mapStateToProps = (state) => ({
  podcastState: state.podcast,
  podcastPlaylistState: state.podcastPlaylist
});

const mapDispatchToProps = (dispatch) => ({
  onRequestNextPodcastEpisode: (podcastId, nextEpisodeValue) =>
    dispatch(requestNextPodcastEpisode(podcastId, nextEpisodeValue)),
  // onFetchPodCastListStart: () => dispatch(fetchPodCastListStart()),
  onSetPlayerPlaylist: (list) => dispatch(setPlayerPlaylist(list)),
  onFetchPodCastEpisodeStart: (id) => dispatch(fetchPodCastEpisodeStart(id)),
  onEpisodePlayerStart: (podcastid, episodeid) =>
    dispatch(episodePlayerStart(podcastid, episodeid)),
});

const container = connect(mapStateToProps, mapDispatchToProps);

export default container;
